// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.external_link_icon{font-weight:600;font-size:10px;position:relative;top:-1px}`, "",{"version":3,"sources":["webpack://./src/matchScreen/styles/Icons/ExternalLinkIcon.scss"],"names":[],"mappings":"AAEA,oBACE,eAAA,CACA,cAAA,CACA,iBAAA,CACA,QAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
